import { ConstantItems, getDefaultConfig } from "../../../constants";
import * as _ from "lodash";
import {
    PortfolioAttributionBenchmarkFM,
    PortfolioAttributionBenchmarkValues,
} from "../models/PortfolioAttributionBenchmarkDto ";

export class AttributionRepo {
    static $inject = ["$http", "config"];

    constructor(
        private $http: angular.IHttpService,
        private config: ConstantItems
    ) {}

    public getPortValuationSummary(
        currency: string,
        portfolioIds: number[],
        date: string
    ) {
        let queryParams = {
            currency,
            portfolioIds,
            date,
        };

        let config = getDefaultConfig();
        config.params = queryParams;
        return this.$http.get(
            `${this.config.portfolioUrl}/valuation-summary`,
            config
        );
    }

    public getQuarterDates(date: string) {
        let queryParams = {
            date,
        };

        let config = getDefaultConfig();
        config.params = queryParams;
        return this.$http.get(
            `${this.config.portfolioUrl}/financial-quarter`,
            config
        );
    }

    public getAssetClassContributionTTM(
        currency: string,
        portfolioIds: number[]
    ) {
        let queryParams = {
            currency,
            portfolioIds,
        };

        let config = getDefaultConfig();
        config.params = queryParams;
        return this.$http.get(
            `${this.config.portfolioUrl}/asset-class-contribution-ttm`,
            config
        );
    }

    public getAssetClassContributionCurrentQuarter(
        currency: string,
        portfolioIds: number[]
    ) {
        let queryParams = {
            currency,
            portfolioIds,
        };

        let config = getDefaultConfig();
        config.params = queryParams;
        return this.$http.get(
            `${this.config.portfolioUrl}/asset-class-contribution-quarter`,
            config
        );
    }
    public getCashValuationSummary(
        currency: string,
        portfolioIds: number[],
        date: string
    ) {
        let queryParams = {
            currency,
            portfolioIds,
            date,
        };

        let config = getDefaultConfig();
        config.params = queryParams;
        return this.$http.get(
            `${this.config.portfolioUrl}/cash-valuation`,
            config
        );
    }

    public getSecurityValuationSummary(
        currency: string,
        portfolioIds: number[],
        date: string
    ) {
        let queryParams = {
            currency,
            portfolioIds,
            date,
        };

        let config = getDefaultConfig();
        config.params = queryParams;
        return this.$http.get(
            `${this.config.portfolioUrl}/security-valuation`,
            config
        );
    }

    public getPortfolioAttributionBenchmarks(clientNumber: string) {
        let queryParams = {
            clientNumber,
        };
        let config = getDefaultConfig();
        config.params = queryParams;
        return this.$http.get(
            `${this.config.portfolioUrl}/portfolio-attribution-benchmarks/${clientNumber}`,
            config
        );
    }

    public updatePortfolioAttributionBenchmarks(
        clientNumber: string,
        portfolioAttributionBenchmark: PortfolioAttributionBenchmarkValues
    ) {
        return this.$http.post(
            `${this.config.portfolioUrl}/portfolio-attribution-benchmarks/${clientNumber}`,
            portfolioAttributionBenchmark
        );
    }

    public addPortfolioAttributionBenchmarkFM(
        clientNumber: string,
        portfolioAttributionBenchmarkFM: PortfolioAttributionBenchmarkFM
    ) {
        return this.$http.post(
            `${this.config.portfolioUrl}/portfolio-attribution-benchmark-fm/${clientNumber}`,
            portfolioAttributionBenchmarkFM
        );
    }

    public getPortfolioAttributionByInvestment(
        clientNumber: string,
        portfolioIds: Array<number>,
        currency: string
    ) {
        let queryParams = {
            clientNumber,
            portfolioIds,
            currency,
        };
        let config = getDefaultConfig();
        config.params = queryParams;
        return this.$http.get(
            `${this.config.portfolioUrl}/portfolio-attribution-valuation-by-investment`,
            config
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/attribution/attribution.repo.ts